export default {
  HIOPOSWEBSERVICES: 'https://hiopos.saas.com.co',
  HIOPOSREPORTS: 'https://hioposreports-co.saas.com.co',
}
